var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "recommend-resume-dialog",
    attrs: {
      "title": _vm.getTitle(),
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#999",
      "margin": "-10px 20px 10px"
    }
  }, [_c('i', {
    staticClass: "el-icon-my-xinxi"
  }), _vm._v("已评估的数据不可重新安排，将被忽略")]), _vm._v(" "), _c('div', {
    key: _vm.preventKey + 'a',
    staticClass: "content-confirm border-radius"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("候选人信息")]), _vm._v(" "), (_vm.isSingle) ? _c('el-row', [_c('el-col', [_c('p', [_c('span', [_vm._v("候选人：" + _vm._s(_vm.confirmInfo.name))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("性别：" + _vm._s(_vm.getSelectMapText('WB_GENDER', _vm.confirmInfo.gender) || '-'))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("手机号：" + _vm._s(_vm.confirmInfo.phone))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("邮箱：" + _vm._s(_vm.confirmInfo.email))])]), _vm._v(" "), _c('p', {
    staticClass: "mt-10"
  }, [_vm._v("当前职位：" + _vm._s(_vm.confirmInfo.position)), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("最高学历学校：" + _vm._s(_vm.confirmInfo.school))]), (_vm.confirmInfo.sLevel) ? _c('span', [_vm._v("【" + _vm._s(_vm.confirmInfo.sLevel) + "】")]) : _vm._e()])])], 1) : _c('el-table', {
    attrs: {
      "data": _vm.multiConfirmInfo
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "候选人",
      "prop": "resumeForm.name",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "性别",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.getSelectMapText('WB_GENDER', scope.row.resumeForm.gender) || '-'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号",
      "prop": "resumeForm.mobilePhone",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "邮箱",
      "prop": "resumeForm.email",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "name",
      "show-overflow-tooltip": true,
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                    " + _vm._s(scope.row.paymentEvaluationForm.status === null ? '未安排' : {
          1: '未评估',
          2: '已评估'
        }[scope.row.paymentEvaluationForm.status]) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "prop": "positionForm.name",
      "align": "center",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "color": "#ff4949"
          },
          attrs: {
            "icon": "el-icon-my-guanbi",
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.multiConfirmInfo.splice(scope.$index, 1)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-form', {
    key: _vm.preventKey + 'b',
    ref: "ruleForm",
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评估人",
      "prop": "evaluatorId"
    }
  }, [_c('user-search', {
    ref: "evaluator",
    attrs: {
      "cacheOptions": _vm.confirmInfo.evaluator
    },
    model: {
      value: (_vm.ruleForm.evaluatorId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "evaluatorId", $$v)
      },
      expression: "ruleForm.evaluatorId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "消息提醒"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "true-label": 1,
      "false-label": 0,
      "label": "邮件"
    },
    model: {
      value: (_vm.ruleForm.isEmail),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "isEmail", $$v)
      },
      expression: "ruleForm.isEmail"
    }
  }), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "true-label": 1,
      "false-label": 0,
      "label": "泡泡"
    },
    model: {
      value: (_vm.ruleForm.isPoPo),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "isPoPo", $$v)
      },
      expression: "ruleForm.isPoPo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aee57440"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/arrangeSalaryDialog.vue
// module id = null
// module chunks = 